export default __webpack_public_path__ + "static/media/brand_10.a2fc1096.png";